module.exports = __webpack_public_path__ + "img/illustration-6-raw.54f1f703.png";